import { Directive, ElementRef, OnInit, Input } from '@angular/core';

@Directive({
    selector: '[appFocus]'
})
export class AppFocusDirective implements OnInit {

    inputElement: HTMLElement;

    constructor(public el: ElementRef) {
        this.inputElement = el.nativeElement;
    }

    ngOnInit() {
        this.el.nativeElement.focus();
    }

}
